import activeTabs from '../../../../../../javascript/modules/Gull/Framework/activeTabs.js';
import stap1 from '../MV7xx/offerteAanvragen/stap1.js';
import stap2 from './offerteAanvragen/stap2.js';
import stap3 from '../MV7xx/offerteAanvragen/stap3.js';
import stap4 from '../MV7xx/offerteAanvragen/stap4.js';

const offerteAanvragen = {

	init() {
		activeTabs.initTab([stap1, stap2, stap3, stap4]);
	},

};

export default offerteAanvragen;
